import React, { useState, useEffect } from "react";
import "./QuestionProcessLogsModal.css";
import Loader from "@material-ui/core/CircularProgress";
import { getQuestionCmsLogs } from "../../api/BookSectionCrop";
import ResponseStatus from "../../enums/ResponseStatus";
import { toast } from "react-toastify";

// -------------------------

const TaskStatusLabelsTr = {
    1: "Görüldü",
    2: "Seçildi",
    3: "Atlandı",
    4: "Hata Var",
    5: "Uyumsuz",
    6: "Onaylayan Görüntüledi",
    7: "Onaylandı",
    8: "Reddedildi",
    9: "Emin Değil",
};

const TaskStatusColors = {
    1: "#3b82f6", // Seen
    2: "#22c55e", // Selected
    3: "#facc15", // Skipped
    4: "#ef4444", // HasError
    5: "#a855f7", // Incompatible
    6: "#06b6d4", // ApproveSeen
    7: "#15803d", // Approve
    8: "#b91c1c", // Reject
    9: "#64748b", // NotSure
};



export default function QuestionProcessLogsModal({
  questionCmsId,
  mode = "view",             // view | reject
  onClose,
  onConfirmReject,
  onAddNote,                 // NEW — callback for "+ Not Ekle"

}) {

    const user = JSON.parse(localStorage.getItem("user"));
    const userAdminToken = sessionStorage.getItem("jwtP");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [comment, setComment] = useState("");
  const [showAddNote, setShowAddNote] = useState(false); // NEW

  useEffect(() => {
    loadLogs();
  }, [questionCmsId]);

  const loadLogs = async () => {
    setLoading(true);
  
    try {
      const res = await getQuestionCmsLogs(questionCmsId, user.Token);
  
      if (res.data.ResponseStatus === ResponseStatus.Success) {
        setLogs(res.data.ResponseData || []);
        setLoading(false);
  
      } else if (res.data.ResponseStatus === ResponseStatus.DataIsNull) {
        setLogs([]); // No logs
        toast.warning("Kayıt bulunamadı.");
        setLoading(false);
  
      } else if (res.data.ResponseStatus === ResponseStatus.Error) {
        toast.error(res.data.ResponseMessage || "Log alınırken hata oluştu");
        setLoading(false);
  
      } else {
        toast.error("Beklenmeyen bir hata oluştu.");
        setLoading(false);
      }
  
    } catch (err) {
      console.error("Log Fetch Error:", err);
      toast.error("Loglar alınırken bir hata oluştu.");
  
    } finally {
      setLoading(false);
    }
  };
  

  // ----- Reject Submit -----
  const submitReject = () => {
    // if (!comment.trim()) return;
    onConfirmReject(comment.trim());
  };

  // ----- Add Note Submit -----
  const submitAddNote = () => {
    if (!comment.trim()) return;

    if (onAddNote) {
      onAddNote(comment.trim()); // send to parent
    }

    setComment("");
    setShowAddNote(false);
  };

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content logs-modal" onClick={(e) => e.stopPropagation()} >

        <button className="close-btn" onClick={onClose}>✕</button>
        <h2 className="modal-title">Kayıt Geçmişi</h2>

        <div className="logs-container">
          {loading ? (
            <div style={{ textAlign: "center", padding: 20 }}>
              <Loader size={60} />
            </div>
          ) : logs.length === 0 ? (
            <div className="empty-logs">Henüz işlem kaydı yok.</div>
          ) : (
            logs.map((log, idx) => (
              <div key={idx} className="log-item">

                <div
                  className="log-status-dot"
                  style={{ backgroundColor: TaskStatusColors[log.Status] }}
                />

                <div className="log-details">
                  <div className="log-date">
                    {new Date(log.CreatedDate).toLocaleString("tr-TR")}
                  </div>

                  <div className="log-status">
                    Durum:{" "}
                    <strong style={{ color: TaskStatusColors[log.CMSTopicLogStatus] }}>
                      {TaskStatusLabelsTr[log.CMSTopicLogStatus]}
                    </strong>
                  </div>

                  <div><strong>Ders:</strong> {log.CourseName}</div>
                  <div><strong>Konu:</strong> {log.SegmentTopicName}</div>
                  <div><strong>Kazanım:</strong> {log.AchievementName}</div>
                  <div><strong>İşlemi Gerçekleştiren Öğretmen:</strong> {log.TeacherId}</div>

                  {log.Comment && (
                    <div className="log-comment">
                      <strong>Yorum:</strong> {log.Comment}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* --------------------
           MODE: VIEW → Add Note
        -------------------- */}
       
          <div style={{ marginTop: 20 }}>

            {!showAddNote ? (
              <div
                style={{
                  cursor: "pointer",
                  marginTop: 10,
                  color: "#2563eb",
                  fontWeight: 500,
                }}
                onClick={() => setShowAddNote(true)}
              >
                + Not Ekle
              </div>
            ) : (
              <>
                <textarea
                  placeholder="Yorum ekleyin..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  style={{
                    width: "100%",
                    height: 100,
                    padding: 10,
                    resize: "vertical",
                    marginBottom: 10,
                  }}
                />

                {mode === "view" && <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <button
                    className="qp-btn cancel"
                    onClick={() => {
                      setShowAddNote(false);
                      setComment("");
                    }}
                  >
                    Vazgeç
                  </button>

                  <button
                    className="qp-btn approve"
                    disabled={comment.trim().length === 0}
                    onClick={submitAddNote}
                  >
                    Kaydet
                  </button>
                </div>}
              </>
            )}
          </div>
 

        {/* --------------------
           MODE: REJECT
        -------------------- */}
        {mode === "reject" && (
          <div style={{ marginTop: 20 }}>
           

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button className="qp-btn cancel" onClick={onClose}>
                Vazgeç
              </button>

              <button
                className="qp-btn reject"
                // disabled={comment.trim().length === 0}
                onClick={submitReject}
              >
                Reddet
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
